import type { Dict } from "../core.js";
import type { configSync as vi } from "../vi/configSync.js";

export const configSync: Dict<typeof vi> = {
  title: "Configuration sync to apps",
  intro:
    "The hub is only where settings are edited. On every save the hub pushes a configuration snapshot to the app; the app stores it in its own database and runs from it — a hub outage does not affect apps.",
  loadFailed: "Could not load the sync status.",
  pushFailed: "Push failed.",
  version: "Version",
  versionValue: "v{current} (app holds v{acked})",
  versionNone: "none",
  receivedAt: "App received",
  lastPushAt: "Last push",
  never: "never",
  lastError: "Last error",
  push: "Push again",
  pushing: "Pushing…",
  "state.not_configured": "Not connected",
  "state.never": "Never pushed",
  "state.in_sync": "In sync",
  "state.pending": "Waiting for app",
  "state.failed": "Push failed",
  notConfiguredHint: "The hub lacks this app's URL / secret (`HQ_<APP>_API_URL`, `HQ_<APP>_SERVICE_SECRET`).",
  savedSyncFailed: "Saved, but pushing to {apps} failed — see « Configuration sync to apps ».",
};
